import { useRouter } from "@tanstack/react-router";
import { X } from "lucide-react";

const REDIRECT_MESSAGES: Record<string, { oldName: string }> = {
  wondercat: { oldName: "Wondercat" },
  degaus: { oldName: "Degaus" },
};

export function RedirectBanner({ from }: { from: string }) {
  const router = useRouter();
  const message = REDIRECT_MESSAGES[from];

  if (!message) return null;

  function dismiss() {
    const url = new URL(window.location.href);
    url.searchParams.delete("from");
    router.navigate({ to: url.pathname + url.search, replace: true });
  }

  return (
    // Mounted in __root outside the route theme scopes; steward-theme.css is
    // loaded globally, so self-scoping with the class resolves the tokens
    // (same pattern as CookieConsent).
    <div className="steward-theme bg-background text-muted-foreground border-border relative flex items-center justify-center border-b px-4 py-2 text-sm">
      <span>
        {message.oldName} is now{" "}
        <span className="font-medium text-[var(--green)]">Wonda</span>. Same
        tools, new name.
      </span>
      <button
        type="button"
        onClick={dismiss}
        className="text-foreground/40 absolute right-4 rounded p-0.5 transition-opacity hover:opacity-100"
        aria-label="Dismiss"
      >
        <X className="size-3.5" />
      </button>
    </div>
  );
}
